export default "__VITE_ASSET__ff9c2052__"